import { Route, Routes } from 'react-router-dom';

import { paths } from 'data/routes';

import { TabType } from 'components/Tabs';

import { Data } from './components/Data';
import { List } from './components/List';
import { Manage } from './components/Manage';

export function NotificationsCategories(): React.ReactElement {
  const tabs: TabType[] = [
    {
      id: 1,
      title: 'Data',
      content: <Data />,
    },
  ];

  return (
    <Routes>
      <Route path="/">
        <Route index element={<List />} />
        <Route
          path={`${paths.manage}/:id`}
          element={<Manage title="Notifications/Categories" tabs={tabs} />}
        />
        <Route
          path={paths.add}
          element={<Manage title="Add new category" tabs={tabs} isNew />}
        />
      </Route>
    </Routes>
  );
}
